import { useState } from 'react'

import { KuniriIcons, kuniriIconWeight } from '@/lib/icons'
import { resolveMediaUrl } from '@/lib/media'

interface ChatAvatarProps {
  name: string
  src?: string | null
  size?: 'sm' | 'md' | 'lg'
}

const SIZE_CLASS = {
  sm: 'chat-avatar chat-avatar--sm',
  md: 'chat-avatar chat-avatar--md',
  lg: 'chat-avatar chat-avatar--lg',
} as const

/**
 * Participant/peer avatar. The name is always rendered next to it, so the
 * image and initials are decorative and the accessible label comes from the
 * surrounding row or link.
 */
export function ChatAvatar({ src, size = 'md' }: ChatAvatarProps) {
  const resolved = resolveMediaUrl(src)
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const failed = Boolean(resolved && failedSrc === resolved)
  const AvatarIcon = KuniriIcons.user

  return (
    <span className={`${SIZE_CLASS[size]} relative`} aria-hidden="true">
      <AvatarIcon size={size === 'lg' ? 28 : 20} weight={kuniriIconWeight} />
      {resolved && !failed ? (
        <img
          src={resolved}
          alt=""
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          className="absolute inset-0 size-full rounded-full object-cover"
          onError={() => setFailedSrc(resolved)}
        />
      ) : null}
    </span>
  )
}
